import { inject, Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { LotMouvement } from "../../models/lot.model";
import { environment } from "../../../../../environments/environment";
import { PaginatedResponse } from "../../models/mouvements.model";
import { TypeMouvement } from "../../enums/type-mouvement.enum";
import { PaginatedEntityApiService } from "../../../../shared/store/pagination/paginated-entity-api.service";
import { QueryParam } from "app/shared/store/store-types.model";
import { queryParamToHttp } from "../../../../shared/store/utils/store-utils.service";

@Injectable({ providedIn: "root" })
export class MouvementApiService
  implements PaginatedEntityApiService<LotMouvement>
{
  loadPage(
    page: number,
    limit: number,
    query?: QueryParam,
  ): Observable<{ data: LotMouvement[]; total: number }> {
    let params = queryParamToHttp({ ...query, page, pageSize: limit });
    return this.httpClient.get<{ data: LotMouvement[]; total: number }>(
      `${environment.api()}/lot_mouvements/search`,
      {
        params,
      },
    );
  }

  loadOne(id: string): Observable<LotMouvement> {
    return this.httpClient.get<LotMouvement>(
      `${environment.api()}/lot_mouvements/id/${id}`,
    );
  }

  httpClient = inject(HttpClient);

  create(entity: LotMouvement): Observable<LotMouvement> {
    throw new Error("Method not implemented.");
  }

  loadAllFilter(filters: {
    page?: number;
    pageSize?: number;
    articleIds?: string[];
    type: TypeMouvement[];
    dates: { start: Date; end: Date };
  }) {
    let params = new HttpParams();
    if (filters.page !== null && filters.page !== undefined) {
      params = params.set("page", filters.page);
    }
    if (filters.pageSize !== null && filters.pageSize !== undefined) {
      params = params.set("pageSize", filters.pageSize);
    }
    if (filters.articleIds?.length) {
      filters.articleIds.forEach((articleId) => {
        params = params.append("articleIds", articleId.toString());
      });
    }
    if (filters.type && filters.type.length > 0) {
      filters.type.forEach((etat) => {
        params = params.append("type", etat.toString());
      });
    }
    if (filters.dates.start) {
      params = params.set("minDate", filters.dates.start.toISOString());
    }
    if (filters.dates.end) {
      params = params.set("maxDate", filters.dates.end.toISOString());
    }
    return this.httpClient.get<PaginatedResponse<LotMouvement>>(
      `${environment.api()}/lot_mouvements/search`,
      {
        params,
      },
    );
  }

  loadByLotId(lotId: string): Observable<LotMouvement[]> {
    return this.httpClient.get<LotMouvement[]>(
      `${environment.api()}/lot_mouvements/lotId/${lotId}`,
    );
  }

  loadByOfId(ofId: string): Observable<LotMouvement[]> {
    return this.httpClient.get<LotMouvement[]>(
      `${environment.api()}/lot_mouvements/of/${ofId}`,
    );
  }

  remove(id: string): Observable<string> {
    return this.httpClient.delete<string>(
      `${environment.api()}/lot_mouvements/id/${id}`,
    );
  }

  update(entity: LotMouvement): Observable<LotMouvement> {
    return this.httpClient.post<LotMouvement>(
      `${environment.api()}/lot_mouvements/update/one`,
      entity,
    );
  }

  loadAll(): Observable<LotMouvement[]> {
    return this.httpClient.get<LotMouvement[]>(
      `${environment.api()}/lot_mouvements`,
    );
  }
}
